// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Ymp","rootNoMargin":"styles_rootNoMargin__1FDAp"};